import PageHeader from '../components/PageHeader.jsx'
import { IconArrow } from '../components/icons.jsx'
import PurposeStrip from '../components/PurposeStrip.jsx'
import { EXTERNAL_URL, EXTERNAL_STAFF_URL } from '../lib/surfaces.js'
import styles from './Presentations.module.css'

/**
 * Team Meeting Rooms — a LAUNCHER into the customer portal at
 * team.srchamp.com, the same discipline as Pricing, Presentations and
 * Top Tier Teams.
 *
 * Brian: "i need this to be where my team goes and clicks into it. that way we
 * look like a fucking enterprise without shit living all over the place."
 *
 * ⚠️ DELIBERATELY NOT EMBEDDED, and this one matters more than the others.
 * app.srchamp.com is the INTERNAL platform — HubSpot data, rep books, pricing,
 * 12,000 championship records. The portal is for people OUTSIDE SR. Putting a
 * customer-facing surface inside the staff app means one auth mistake hands a
 * coach the rep books. It stays its own deployment, with its own sign-in, and
 * the hub is the front door.
 *
 * No data is mirrored here either. The portal owns the accounts, the
 * credentials and the approval record; a copy in the hub would drift, and the
 * approval record is the one thing that must not.
 */
/* Read from lib/surfaces.js rather than re-typed here. Two files holding the
 * same URL is how one of them ends up pointing at a dead host. */
const PORTAL_URL = EXTERNAL_URL
const STAFF_URL = EXTERNAL_STAFF_URL

export default function TeamRooms() {
  return (
    <div className="fade-up">
      <PageHeader
        eyebrow="Customer-facing"
        title="Team Meeting Rooms"
        lead="SR’s one external surface. Approvals and signatures, rosters and timestamps, the review ask, marketing material, delivery assets, and the contract — all recorded where the customer can see them. You issue the login; they only ever see their own team."
      />

      <PurposeStrip which="external" />

      <div className={styles.hero}>
        <div className={styles.heroMain}>
          <img
            className={styles.seal}
            src="/brand/sr-monogram.png"
            alt=""
            width="46"
            height="46"
            aria-hidden="true"
          />

          <div className={styles.badge}>
            <span className={styles.badgeDot} />
            Live · standalone portal
          </div>

          <h2 className={styles.heroTitle}>Open the console to issue a coach a login.</h2>
          <p className={styles.heroLead}>
            The portal runs as its own application at{' '}
            <span className={styles.mono}>team.srchamp.com</span>. Sign in with
            your <span className={styles.mono}>app.srchamp.com</span> username
            and password — the same one you used here, there is no second
            credential to remember.
          </p>

          <div className={styles.actions}>
            <a
              className={`btn btn-primary ${styles.cta}`}
              href={STAFF_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open the team console
              <IconArrow width={17} height={17} />
            </a>
            <a
              className={`btn ${styles.ctaGhost}`}
              href={PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              The coach’s sign-in page
            </a>
          </div>
          <span className={styles.ctaNote}>
            Both open in a new tab · your app.srchamp.com password works there
          </span>
        </div>

        <ul className={styles.points}>
          <li>
            <strong>The three things a coach opens it for</strong> — the 14
            manufacturing stages with the current one marked, the 7 approvals
            with who each is waiting on, and who has ordered.
          </li>
          <li>
            <strong>Everything SR puts in front of a customer lands here</strong>{' '}
            — approvals and signatures, the roster, the timestamps, the review
            ask once they have the rings, marketing material for their point of
            contact, assets for a delivery event, and the contract when they are
            happy. One place, so there is one record of what they agreed to.
          </li>
          <li>
            <strong>Approvals are theirs, not ours</strong> — SR records its own
            steps and the third party’s; the customer’s steps can only be
            recorded by the customer. An approval SR clicked on their behalf
            would not be evidence of anything.
          </li>
          <li>
            <strong>Orders come live from Shopify</strong> — matched to a team
            by the order tag, showing the ATHLETE from the line item rather than
            the parent who paid.
          </li>
          <li>
            <strong>Any rep can issue a coach a login</strong> — customer access
            only. Staff logins are created here in Team Management, never there.
          </li>
        </ul>
      </div>

      <p className={styles.legacy}>
        The portal runs as its own application so that a customer-facing sign-in
        never shares a surface with rep assignments, pricing or the championship
        object. The hub links to it rather than embedding it. If a button
        doesn’t open, go directly to{' '}
        <a
          className={styles.legacyLink}
          href={PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          team.srchamp.com
        </a>
        .
      </p>
    </div>
  )
}
